import React from "react"
import Tooltip, { TooltipProps } from "@mui/material/Tooltip"

import { tooltipCommonStyles } from "@shared/components/theme"
import { resolveTooltipTitle } from "./tooltipRegistry"

const AppTooltip: React.FC<TooltipProps> = ({ title, slotProps, ...props }) => {
  const tooltipSlotProps = slotProps?.tooltip ?? {}
  const arrowSlotProps = slotProps?.arrow ?? {}
  const popperSlotProps = slotProps?.popper ?? {}
  const baseTooltipSx = tooltipCommonStyles.blue.slotProps.tooltip.sx
  const baseArrowSx = tooltipCommonStyles.blue.slotProps.arrow.sx
  const popperModifiers = (popperSlotProps as { modifiers?: Array<{ name?: string; options?: { offset?: [number, number] } }> }).modifiers ?? []
  const hasOffsetModifier = popperModifiers.some(modifier => modifier?.name === "offset")
  const mergedPopperModifiers = hasOffsetModifier
    ? popperModifiers
    : [
        ...popperModifiers,
        {
          name: "offset",
          options: {
            offset: [0, -8],
          },
        },
      ]
  return (
    <Tooltip
      {...props}
      title={resolveTooltipTitle(title)}
      slotProps={{
        ...slotProps,
        popper: {
          ...popperSlotProps,
          modifiers: mergedPopperModifiers,
        },
        tooltip: {
          ...tooltipSlotProps,
          sx: {
            ...baseTooltipSx,
            ...(tooltipSlotProps as { sx?: object }).sx,
          },
        },
        arrow: {
          ...arrowSlotProps,
          sx: {
            ...baseArrowSx,
            ...(arrowSlotProps as { sx?: object }).sx,
          },
        },
      }}
    />
  )
}

export default AppTooltip
